import React from 'react';
import { getTranslation } from '../utils/config';
import { useDfContext } from '../context/df-context';
import { UPDATE_TOAST } from '../context/actions';

export default function Toast(): React.ReactElement {
  const {
    state: { showToast, message },
    dispatch,
  } = useDfContext();

  React.useEffect(() => {
    if (showToast) {
      const timer = setTimeout(() => {
        dispatch({
          type: UPDATE_TOAST,
          showToast: false,
        });
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [dispatch, showToast]);

  const handleClose = () => {
    dispatch({
      type: UPDATE_TOAST,
      showToast: false,
    });
  };

  return (
    <div className="toast-area">
      <div className={`toast ${showToast ? 'showing' : 'hide'}`} role="alert">
        <div className="d-flex">
          <div className="toast-body">{message}</div>
          <button className="btn-close" type="button" onClick={handleClose}>
            <span className="hidden">{getTranslation('toast_close')}</span>
          </button>
        </div>
      </div>
    </div>
  );
}
